import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetToSubFolder } from "../../../Redux/Slices/Folder";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { IoIosArrowBack } from "react-icons/io";
import { FaEye, FaUser, FaEnvelope, FaPhone } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const EmployerSubfolder = () => {
  const navigate = useNavigate();
  const [entriesToShow, setEntriesToShow] = useState(10);

  const { id } = useParams();
  const [subfolderdetails, setSubfolderdetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handlesubfolder = async () => {
    let res = await GetToSubFolder(id);
    setSubfolderdetails(res?.data);
  };

  const handleEntriesChange = (e) => {
    setEntriesToShow(Number(e.target.value));
  };

  useEffect(() => {
    handlesubfolder();
    document.title = "Folder Details | CAJobPortal";
  }, []);

  const filteredData = subfolderdetails
    .slice(0, entriesToShow)
    .filter(
      (item) =>
        item?.user_id?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.user_id?.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.user_id?.mobile?.includes(searchQuery)
    );

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'My Folders', 'Folder Details']}>
        <div className="employer-page-header">
          <div>
            <button
              onClick={() => navigate(-1)}
              className="employer-btn employer-btn-ghost employer-mb-2"
            >
              <IoIosArrowBack /> Back to Folders
            </button>
            <h1 className="employer-page-title">Folder Candidates</h1>
          </div>
        </div>

        <div className="employer-card">
          {/* Table Controls */}
          <div className="employer-card-header">
            <div className="employer-flex employer-justify-between employer-items-center" style={{ flexWrap: 'wrap', gap: '1rem' }}>
              <div className="employer-flex employer-items-center employer-gap-2">
                <label style={{ fontSize: '0.875rem', color: 'var(--employer-text-secondary)' }}>
                  Show
                </label>
                <select
                  value={entriesToShow}
                  onChange={handleEntriesChange}
                  className="employer-form-select"
                  style={{ width: 'auto', padding: '0.375rem 0.75rem' }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <label style={{ fontSize: '0.875rem', color: 'var(--employer-text-secondary)' }}>
                  entries
                </label>
              </div>
              <div>
                <input
                  className="employer-form-input"
                  type="search"
                  placeholder="Search by name, email or phone..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{ minWidth: '250px' }}
                />
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="employer-table-container">
            <table className="employer-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="employer-flex employer-items-center employer-gap-2">
                          <FaUser style={{ color: 'var(--employer-primary)' }} />
                          <span>{item?.user_id?.name || 'N/A'}</span>
                        </div>
                      </td>
                      <td>
                        <div className="employer-flex employer-items-center employer-gap-2">
                          <FaEnvelope style={{ color: 'var(--employer-text-muted)', fontSize: '0.875rem' }} />
                          <span>{item?.user_id?.email || 'N/A'}</span>
                        </div>
                      </td>
                      <td>
                        <div className="employer-flex employer-items-center employer-gap-2">
                          <FaPhone style={{ color: 'var(--employer-text-muted)', fontSize: '0.875rem' }} />
                          <span>{item?.user_id?.mobile || 'N/A'}</span>
                        </div>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            navigate(`/employer/Jobseeker/${item?.user_id?._id}`)
                          }
                          className="employer-btn employer-btn-sm employer-btn-primary"
                        >
                          <FaEye /> View Profile
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="employer-table-empty">
                      {searchQuery ? 'No candidates found matching your search' : 'No candidates in this folder'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Info */}
          {subfolderdetails.length > 0 && (
            <div className="employer-pagination">
              <div className="employer-pagination-info">
                Showing {Math.min(filteredData.length, entriesToShow)} of {subfolderdetails.length} candidates
              </div>
            </div>
          )}
        </div>
      </EmployerLayout>
    </div>
  );
};

export default EmployerSubfolder;
